import { Address } from 'nftx.js';
import useV2Positions from './useV2Positions';
import { useMemo } from 'react';

const useV2Position = ({
  positionId,
  userAddress,
}: {
  userAddress: Address | undefined;
  positionId: string;
}) => {
  const query = useV2Positions({ userAddress });
  const data = useMemo(() => {
    if (!positionId || !query.data) {
      return undefined;
    }

    return query.data.find((position) => position.id === positionId);
  }, [positionId, query.data]);

  return { ...query, data };
};

export default useV2Position;
